import { render, staticRenderFns } from "./MenuSetDefault.vue?vue&type=template&id=f0c51adc&scoped=true"
import script from "./MenuSetDefault.vue?vue&type=script&lang=js"
export * from "./MenuSetDefault.vue?vue&type=script&lang=js"
import style0 from "./MenuSetDefault.vue?vue&type=style&index=0&id=f0c51adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c51adc",
  null
  
)

export default component.exports